"use client";

import { useEffect, useState } from "react";
import GoogleAd from "./GoogleAd";
import styles from "./InContentAd.module.css";

/**
 * In-content ad unit for tool pages. Renders only after mount to avoid hydration mismatch.
 * Create a separate "In-content" ad unit in AdSense and pass its slot ID for best results.
 */
export default function InContentAd() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div className={styles.placeholder} aria-hidden />;
  }

  return (
    <div className={`w-100 ${styles.container}`}>
      <GoogleAd slot="1234567890" format="rectangle" responsive />
    </div>
  );
}
